export default __webpack_public_path__ + "static/media/sharp-icon.d4bdfe2c.svg";